import { IOffer } from '../../../../types/offerData';
import { getCommercialAreaForMultiAds } from '../../../../utils/offer_helpers';

type IGetCommercialMultiAdsFloorConfig = (building: IOffer) => [string, string];

export const getCommercialMultiAdsAreaConfig: IGetCommercialMultiAdsFloorConfig = offer => {
  const { maxArea, minArea } = offer;

  return ['Площади', getCommercialAreaForMultiAds(minArea, maxArea)];
};
